import './FormRow.scss'

import React from 'react'

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {"xs"|"md"|"lg"|"xl"} [props.variant]
 */
const FormRow = ({ children, variant }) => (
    <div className={'form-row' + (variant ? '-' + variant : '')}>
        {children}
    </div>
)

export default FormRow
